import { isStringNullOrWhiteSpace } from 'owa-localize';

import { SubstrateSearchSuggestionsResponsePeopleSuggestion } from 'owa-search-service';
import FindRecipientPersonaType from '../store/schema/FindRecipientPersonaType';
import isEmailAddressMasked from 'owa-substrate-people-suggestions/lib/utils/isEmailAddressMasked';

export default function convertSuggestionToPersonaType(
    suggestion: SubstrateSearchSuggestionsResponsePeopleSuggestion,
    transactionId: string,
    returnMaskedRecipients?: boolean
) {
    const {
        EmailAddresses,
        DisplayName,
        Text,
        PDLItemId,
        ADObjectId,
        PersonaId,
        FeatureData,
        Id,
        ReferenceId,
        ImAddress,
        JobTitle,
        PeopleSubtype,
    } = suggestion;

    const emailAddress = EmailAddresses ? EmailAddresses[0] : null;

    if (!returnMaskedRecipients && isEmailAddressMasked(emailAddress)) {
        return null;
    }

    const emailAddressWrapper = {
        EmailAddress: emailAddress,
        Name: isStringNullOrWhiteSpace(DisplayName) ? Text : DisplayName,
        MailboxType: getMailboxType(PeopleSubtype),
        RoutingType: getRoutingType(PeopleSubtype),
        ItemId: PDLItemId ? { Id: PDLItemId, __type: 'ItemId:#Exchange' } : null,
    };
    const findRecipientPersonaType: FindRecipientPersonaType = {
        DisplayName,
        ADObjectId,
        FeatureData,
        Id,
        ImAddress,
        EmailAddress: emailAddressWrapper,
        EmailAddresses: [emailAddressWrapper],
        PersonaTypeString: getPersonaTypeString(PeopleSubtype),
        PersonaId: { Id: PersonaId },
        Title: JobTitle,
        ReferenceId,
        TransactionId: transactionId,
    };

    return findRecipientPersonaType;
}

function getRoutingType(contactType: string) {
    if (contactType == 'PersonalDistributionList') {
        return 'MAPIPDL';
    }
    return 'SMTP';
}

function getPersonaTypeString(contactType: string) {
    switch (contactType) {
        case 'PublicDistributionList':
        case 'PersonalDistributionList':
            return 'DistributionList';
        case 'UnifiedGroup':
            return 'ModernGroup';
        case 'OrganizationUser':
        case 'PersonalContact':
        case 'ImplicitContact':
        case 'OrganizationContact':
            return 'Person';
        case 'LinkedIn':
            return 'LinkedIn';
        case 'ImplicitGroup':
            return 'ImplicitGroup';
        default:
            return 'Unknown';
    }
}

function getMailboxType(contactType: string) {
    switch (contactType) {
        case 'PublicDistributionList':
            return 'PublicDL';
        case 'PersonalDistributionList':
            return 'PrivateDL';
        case 'UnifiedGroup':
            return 'GroupMailbox';
        case 'ImplicitGroup':
            return 'RecommendedGroup';
        case 'OrganizationUser':
            return 'InternalMailbox';
        case 'LinkedIn':
            return 'LinkedIn';
        case 'PersonalContact':
        case 'OrganizationContact':
        case 'ImplicitContact':
        case 'Guest':
        case 'Unknown':
            return 'ExternalMailbox';
        default:
            return contactType;
    }
}
